module.exports = __webpack_public_path__ + "img/cd.cec720ee.svg";